import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';
import { TranslocoModule } from '@ngneat/transloco';
import * as XLSX from 'xlsx';

@Component({
    selector: 'app-performance-of-agents',
    standalone: true,
    imports: [
        MatCardModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatButtonModule,
        TranslocoModule,
    ],
    templateUrl: './performance-of-agents.component.html',
    styleUrl: './performance-of-agents.component.scss',
})
export class PerformanceOfAgentsComponent {
    @Input() name: string = '';
    @Input() data: Project[] = [];

    displayedColumns: string[] = [
        'supervisorName',
        'assessmentName',
        'severityLevel',
        'numberVulnerabilities',
    ];
    dataSource = new MatTableDataSource<Project>(this.data);

    pageSizes = [10, 20, 50, 1000];

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('TABLE') table: ElementRef;

    // isToggled
    isToggled = false;

    constructor(public themeService: CustomizerSettingsService) {
        this.themeService.isToggled$.subscribe((isToggled) => {
            this.isToggled = isToggled;
        });
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    // Search Filter
    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    // onKeydown
    onKeydown(event: Event) {
        //console.log(event);
        return false;
    }

    // Dark Mode
    toggleTheme() {
        this.themeService.toggleTheme();
    }

    // RTL Mode
    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }

    // changeData
    changeData() {
        this.dataSource.data = this.data;
    }

    exportTOExcel() {
        const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
            this.table.nativeElement
        );
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'ProjectsBySupervisor');

        /* save to file */
        XLSX.writeFile(wb, 'export.xlsx');
    }
}

export interface Project {
    supervisorName: string;
    assessmentName: string;
    severityLevel: string;
    color: string;
    numberVulnerabilities: number;
}
